export default __webpack_public_path__ + "static/media/KheshattaCityMap.65aec139.jpg";